"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_socket_service_1 = __importDefault(require("./base-socket-service"));
const asset_1 = __importDefault(require("./../models/asset"));
const gateway_1 = __importDefault(require("./../models/gateway"));
const gatewaySoftwareVersion_1 = __importDefault(require("./../models/gatewaySoftwareVersion"));
const site_1 = __importDefault(require("./../models/site"));
const order_1 = __importDefault(require("./../models/order"));
const session_1 = __importDefault(require("./../models/session"));
const discount_1 = __importDefault(require("./../models/discount"));
const stripeSession_1 = __importDefault(require("./../models/stripeSession"));
const stripeWebhook_1 = __importDefault(require("./../models/stripeWebhook"));
const zapierWebhook_1 = __importDefault(require("./../models/zapierWebhook"));
const places_1 = __importDefault(require("./../models/places"));
const product_1 = __importDefault(require("./../models/product"));
const modbusModel_1 = __importDefault(require("./../models/modbusModel"));
const occupancySchedule_1 = __importDefault(require("./../models/occupancySchedule"));
const pubOrg_1 = __importDefault(require("./../models/pubOrg"));
const organisation_1 = __importDefault(require("./../models/organisation"));
const paymentCard_1 = __importDefault(require("./../models/paymentCard"));
const assetEvent_1 = __importDefault(require("./../models/assetEvent"));
const gatewayEvent_1 = __importDefault(require("./../models/gatewayEvent"));
const assetTelemetry_1 = __importDefault(require("./../models/assetTelemetry"));
const rule_1 = __importDefault(require("./../models/rule"));
const dataRequest_1 = __importDefault(require("./../models/dataRequest"));
const dataRequestLink_1 = __importDefault(require("./../models/dataRequestLink"));
const invoiceRequest_1 = __importDefault(require("./../models/invoiceRequest"));
const invoiceRequestLink_1 = __importDefault(require("./../models/invoiceRequestLink"));
const siteGroup_1 = __importDefault(require("./../models/siteGroup"));
const group_1 = __importDefault(require("./../models/group"));
const duckChargeAdmin_1 = __importDefault(require("./../models/duckChargeAdmin"));
const customFieldType_1 = __importDefault(require("./../models/customFieldType"));
const customField_1 = __importDefault(require("./../models/customField"));
const location_1 = __importDefault(require("./../models/location"));
const searchHistory_1 = __importDefault(require("./../models/searchHistory"));
const tariff_1 = __importDefault(require("./../models/tariff"));
const groupType_1 = __importDefault(require("./../models/groupType"));
const calculatorInbound_1 = __importDefault(require("./../models/calculatorInbound"));
const calculatorResult_1 = __importDefault(require("./../models/calculatorResult"));
const createReport_1 = __importDefault(require("./../models/createReport"));
const reportHistory_1 = __importDefault(require("./../models/reportHistory"));
const report_1 = __importDefault(require("./../models/report"));
const reportFile_1 = __importDefault(require("./../models/reportFile"));
const gaiaConversation_1 = __importDefault(require("./../models/gaiaConversation"));
const gaiaMessage_1 = __importDefault(require("./../models/gaiaMessage"));
const dataCategory_1 = __importDefault(require("./../models/dataCategory"));
const dataType_1 = __importDefault(require("./../models/dataType"));
const deviceCategory_1 = __importDefault(require("./../models/deviceCategory"));
const widgetBoard_1 = __importDefault(require("./../models/widgetBoard"));
const reportFileLink_1 = __importDefault(require("./../models/reportFileLink"));
const ruleEvent_1 = __importDefault(require("./../models/ruleEvent"));
const audit_1 = __importDefault(require("./../models/audit"));
const application_1 = __importDefault(require("./../models/application"));
const anomalyModel_1 = __importDefault(require("./../models/anomalyModel"));
const anomaly_1 = __importDefault(require("./../models/anomaly"));
const gridduckSubscription_1 = __importDefault(require("./../models/gridduckSubscription"));
const gridduckInvoice_1 = __importDefault(require("./../models/gridduckInvoice"));
const account_1 = __importDefault(require("./../models/account"));
const customFieldData_1 = __importDefault(require("./../models/customFieldData"));
const preferences_1 = __importDefault(require("./../models/preferences"));
const dcRetryPayment_1 = __importDefault(require("./../models/dcRetryPayment"));
const issue_1 = __importDefault(require("./../models/issue"));
const ignoredDevice_1 = __importDefault(require("./../models/ignoredDevice"));
const resetSecret_1 = __importDefault(require("./../models/resetSecret"));
const requestSecret_1 = __importDefault(require("./../models/requestSecret"));
const assetIdentification_1 = __importDefault(require("./../models/assetIdentification"));
const getPhaseBreakdown_1 = __importDefault(require("./../models/getPhaseBreakdown"));
const availableGateway_1 = __importDefault(require("./../models/availableGateway"));
const assetDemand_1 = __importDefault(require("./../models/assetDemand"));
const assetConsumption_1 = __importDefault(require("./../models/assetConsumption"));
const physicalGateway_1 = __importDefault(require("./../models/physicalGateway"));
const sitePermission_1 = __importDefault(require("./../models/sitePermission"));
const applianceCategory_1 = __importDefault(require("./../models/applianceCategory"));
const applianceType_1 = __importDefault(require("./../models/applianceType"));
const dataUpload_1 = __importDefault(require("./../models/dataUpload"));
const file_1 = __importDefault(require("./../models/file"));
const zip_1 = __importDefault(require("./../models/zip"));
const search_1 = __importDefault(require("./../models/search"));
const verifyOrgInvite_1 = __importDefault(require("./../models/verifyOrgInvite"));
const confirmOrgInvite_1 = __importDefault(require("./../models/confirmOrgInvite"));
const dcCreateAccount_1 = __importDefault(require("./../models/dcCreateAccount"));
const dcSession_1 = __importDefault(require("./../models/dcSession"));
const paymentSheet_1 = __importDefault(require("./../models/paymentSheet"));
const dcChargePoint_1 = __importDefault(require("./../models/dcChargePoint"));
const dcChargeStation_1 = __importDefault(require("./../models/dcChargeStation"));
const organisationInvite_1 = __importDefault(require("./../models/organisationInvite"));
const organisationMember_1 = __importDefault(require("./../models/organisationMember"));
const detectedDevice_1 = __importDefault(require("./../models/detectedDevice"));
const resetToken_1 = __importDefault(require("./../models/resetToken"));
const password_1 = __importDefault(require("./../models/password"));
const thirdPartyIntegration_1 = __importDefault(require("./../models/thirdPartyIntegration"));
const orgPartner_1 = __importDefault(require("./../models/orgPartner"));
const mfaSecret_1 = __importDefault(require("./../models/mfaSecret"));
const mfaVerification_1 = __importDefault(require("./../models/mfaVerification"));
const mfaAuthentication_1 = __importDefault(require("./../models/mfaAuthentication"));
const loginAs_1 = __importDefault(require("./../models/loginAs"));
const loginAsPartner_1 = __importDefault(require("./../models/loginAsPartner"));
const organisationManagement_1 = __importDefault(require("./../models/organisationManagement"));
const stagingDatabase_1 = __importDefault(require("./../models/stagingDatabase"));
const notification_1 = __importDefault(require("./../models/notification"));
const zigbeeFirmware_1 = __importDefault(require("./../models/zigbeeFirmware"));
const gatewayTrustList_1 = __importDefault(require("./../models/gatewayTrustList"));
const gatewayTrustedDeviceUntrustRequest_1 = __importDefault(require("./../models/gatewayTrustedDeviceUntrustRequest"));
const telemetryOperation_1 = __importDefault(require("./../models/telemetryOperation"));
const aggregateTelemetryGroupRequest_1 = __importDefault(require("./../models/aggregateTelemetryGroupRequest"));
const assetRemoveDataRequest_1 = __importDefault(require("./../models/assetRemoveDataRequest"));
const assetAggregateDataRequest_1 = __importDefault(require("./../models/assetAggregateDataRequest"));
const gatewayTrustedDeviceAnalysis_1 = __importDefault(require("./../models/gatewayTrustedDeviceAnalysis"));
const aggregateTelemetry_1 = __importDefault(require("./../models/aggregateTelemetry"));
const instantaneousTelemetry_1 = __importDefault(require("./../models/instantaneousTelemetry"));
const organisationSearch_1 = __importDefault(require("./../models/organisationSearch"));
const gatewayLogDownloadRequest_1 = __importDefault(require("./../models/gatewayLogDownloadRequest"));
const gatewayEnhancedLogDownloadRequest_1 = __importDefault(require("./../models/gatewayEnhancedLogDownloadRequest"));
const gatewayGod_1 = __importDefault(require("./../models/gatewayGod"));
const assetGod_1 = __importDefault(require("./../models/assetGod"));
const assetTelemetryBatch_1 = __importDefault(require("./../models/assetTelemetryBatch"));
const assetConsumptionBatch_1 = __importDefault(require("./../models/assetConsumptionBatch"));
const rawAggregateData_1 = __importDefault(require("./../models/rawAggregateData"));
const assetReset_1 = __importDefault(require("./../models/assetReset"));
const inspiredLogin_1 = __importDefault(require("./../models/inspiredLogin"));
const dataUnit_1 = __importDefault(require("./../models/dataUnit"));
const itemMetadata_1 = __importDefault(require("./../models/itemMetadata"));
class SocketService extends base_socket_service_1.default {
    createObject(type, createObject) {
        let object;
        switch (type) {
            case 'asset':
                object = new asset_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.assets, object);
                return object;
                break;
            case 'gateway':
                object = new gateway_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.gateways, object);
                return object;
                break;
            case 'gatewaySoftwareVersion':
                object = new gatewaySoftwareVersion_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.gatewaySoftwareVersions, object);
                return object;
                break;
            case 'site':
                object = new site_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.sites, object);
                return object;
                break;
            case 'order':
                object = new order_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.orders, object);
                return object;
                break;
            case 'session':
                object = new session_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.sessions, object);
                return object;
                break;
            case 'discount':
                object = new discount_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.discounts, object);
                return object;
                break;
            case 'stripeSession':
                object = new stripeSession_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.stripeSessions, object);
                return object;
                break;
            case 'stripeWebhook':
                object = new stripeWebhook_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.stripeWebhooks, object);
                return object;
                break;
            case 'zapierWebhook':
                object = new zapierWebhook_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.zapierWebhooks, object);
                return object;
                break;
            case 'places':
                object = new places_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.placess, object);
                return object;
                break;
            case 'product':
                object = new product_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.products, object);
                return object;
                break;
            case 'modbusModel':
                object = new modbusModel_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.modbusModels, object);
                return object;
                break;
            case 'occupancySchedule':
                object = new occupancySchedule_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.occupancySchedules, object);
                return object;
                break;
            case 'pubOrg':
                object = new pubOrg_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.pubOrgs, object);
                return object;
                break;
            case 'organisation':
                object = new organisation_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.organisations, object);
                return object;
                break;
            case 'paymentCard':
                object = new paymentCard_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.paymentCards, object);
                return object;
                break;
            case 'assetEvent':
                object = new assetEvent_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.assetEvents, object);
                return object;
                break;
            case 'gatewayEvent':
                object = new gatewayEvent_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.gatewayEvents, object);
                return object;
                break;
            case 'assetTelemetry':
                object = new assetTelemetry_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.assetTelemetrys, object);
                return object;
                break;
            case 'rule':
                object = new rule_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.rules, object);
                return object;
                break;
            case 'dataRequest':
                object = new dataRequest_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.dataRequests, object);
                return object;
                break;
            case 'dataRequestLink':
                object = new dataRequestLink_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.dataRequestLinks, object);
                return object;
                break;
            case 'invoiceRequest':
                object = new invoiceRequest_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.invoiceRequests, object);
                return object;
                break;
            case 'invoiceRequestLink':
                object = new invoiceRequestLink_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.invoiceRequestLinks, object);
                return object;
                break;
            case 'siteGroup':
                object = new siteGroup_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.siteGroups, object);
                return object;
                break;
            case 'group':
                object = new group_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.groups, object);
                return object;
                break;
            case 'duckChargeAdmin':
                object = new duckChargeAdmin_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.duckChargeAdmins, object);
                return object;
                break;
            case 'customFieldType':
                object = new customFieldType_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.customFieldTypes, object);
                return object;
                break;
            case 'customField':
                object = new customField_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.customFields, object);
                return object;
                break;
            case 'location':
                object = new location_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.locations, object);
                return object;
                break;
            case 'searchHistory':
                object = new searchHistory_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.searchHistorys, object);
                return object;
                break;
            case 'tariff':
                object = new tariff_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.tariffs, object);
                return object;
                break;
            case 'groupType':
                object = new groupType_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.groupTypes, object);
                return object;
                break;
            case 'calculatorInbound':
                object = new calculatorInbound_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.calculatorInbounds, object);
                return object;
                break;
            case 'calculatorResult':
                object = new calculatorResult_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.calculatorResults, object);
                return object;
                break;
            case 'createReport':
                object = new createReport_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.createReports, object);
                return object;
                break;
            case 'reportHistory':
                object = new reportHistory_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.reportHistorys, object);
                return object;
                break;
            case 'report':
                object = new report_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.reports, object);
                return object;
                break;
            case 'reportFile':
                object = new reportFile_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.reportFiles, object);
                return object;
                break;
            case 'gaiaConversation':
                object = new gaiaConversation_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.gaiaConversations, object);
                return object;
                break;
            case 'gaiaMessage':
                object = new gaiaMessage_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.gaiaMessages, object);
                return object;
                break;
            case 'dataCategory':
                object = new dataCategory_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.dataCategorys, object);
                return object;
                break;
            case 'dataType':
                object = new dataType_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.dataTypes, object);
                return object;
                break;
            case 'deviceCategory':
                object = new deviceCategory_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.deviceCategorys, object);
                return object;
                break;
            case 'widgetBoard':
                object = new widgetBoard_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.widgetBoards, object);
                return object;
                break;
            case 'reportFileLink':
                object = new reportFileLink_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.reportFileLinks, object);
                return object;
                break;
            case 'ruleEvent':
                object = new ruleEvent_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.ruleEvents, object);
                return object;
                break;
            case 'audit':
                object = new audit_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.audits, object);
                return object;
                break;
            case 'application':
                object = new application_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.applications, object);
                return object;
                break;
            case 'anomalyModel':
                object = new anomalyModel_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.anomalyModels, object);
                return object;
                break;
            case 'anomaly':
                object = new anomaly_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.anomalys, object);
                return object;
                break;
            case 'gridduckSubscription':
                object = new gridduckSubscription_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.gridduckSubscriptions, object);
                return object;
                break;
            case 'gridduckInvoice':
                object = new gridduckInvoice_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.gridduckInvoices, object);
                return object;
                break;
            case 'account':
                object = new account_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.accounts, object);
                return object;
                break;
            case 'customFieldData':
                object = new customFieldData_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.customFieldDatas, object);
                return object;
                break;
            case 'preferences':
                object = new preferences_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.preferencess, object);
                return object;
                break;
            case 'dcRetryPayment':
                object = new dcRetryPayment_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.dcRetryPayments, object);
                return object;
                break;
            case 'issue':
                object = new issue_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.issues, object);
                return object;
                break;
            case 'ignoredDevice':
                object = new ignoredDevice_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.ignoredDevices, object);
                return object;
                break;
            case 'resetSecret':
                object = new resetSecret_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.resetSecrets, object);
                return object;
                break;
            case 'requestSecret':
                object = new requestSecret_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.requestSecrets, object);
                return object;
                break;
            case 'assetIdentification':
                object = new assetIdentification_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.assetIdentifications, object);
                return object;
                break;
            case 'getPhaseBreakdown':
                object = new getPhaseBreakdown_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.getPhaseBreakdowns, object);
                return object;
                break;
            case 'availableGateway':
                object = new availableGateway_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.availableGateways, object);
                return object;
                break;
            case 'assetDemand':
                object = new assetDemand_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.assetDemands, object);
                return object;
                break;
            case 'assetConsumption':
                object = new assetConsumption_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.assetConsumptions, object);
                return object;
                break;
            case 'physicalGateway':
                object = new physicalGateway_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.physicalGateways, object);
                return object;
                break;
            case 'sitePermission':
                object = new sitePermission_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.sitePermissions, object);
                return object;
                break;
            case 'applianceCategory':
                object = new applianceCategory_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.applianceCategorys, object);
                return object;
                break;
            case 'applianceType':
                object = new applianceType_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.applianceTypes, object);
                return object;
                break;
            case 'dataUpload':
                object = new dataUpload_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.dataUploads, object);
                return object;
                break;
            case 'file':
                object = new file_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.files, object);
                return object;
                break;
            case 'zip':
                object = new zip_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.zips, object);
                return object;
                break;
            case 'search':
                object = new search_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.searchs, object);
                return object;
                break;
            case 'verifyOrgInvite':
                object = new verifyOrgInvite_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.verifyOrgInvites, object);
                return object;
                break;
            case 'confirmOrgInvite':
                object = new confirmOrgInvite_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.confirmOrgInvites, object);
                return object;
                break;
            case 'dcCreateAccount':
                object = new dcCreateAccount_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.dcCreateAccounts, object);
                return object;
                break;
            case 'dcSession':
                object = new dcSession_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.dcSessions, object);
                return object;
                break;
            case 'paymentSheet':
                object = new paymentSheet_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.paymentSheets, object);
                return object;
                break;
            case 'dcChargePoint':
                object = new dcChargePoint_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.dcChargePoints, object);
                return object;
                break;
            case 'dcChargeStation':
                object = new dcChargeStation_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.dcChargeStations, object);
                return object;
                break;
            case 'organisationInvite':
                object = new organisationInvite_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.organisationInvites, object);
                return object;
                break;
            case 'organisationMember':
                object = new organisationMember_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.organisationMembers, object);
                return object;
                break;
            case 'detectedDevice':
                object = new detectedDevice_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.detectedDevices, object);
                return object;
                break;
            case 'resetToken':
                object = new resetToken_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.resetTokens, object);
                return object;
                break;
            case 'password':
                object = new password_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.passwords, object);
                return object;
                break;
            case 'thirdPartyIntegration':
                object = new thirdPartyIntegration_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.thirdPartyIntegrations, object);
                return object;
                break;
            case 'orgPartner':
                object = new orgPartner_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.orgPartners, object);
                return object;
                break;
            case 'mfaSecret':
                object = new mfaSecret_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.mfaSecrets, object);
                return object;
                break;
            case 'mfaVerification':
                object = new mfaVerification_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.mfaVerifications, object);
                return object;
                break;
            case 'mfaAuthentication':
                object = new mfaAuthentication_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.mfaAuthentications, object);
                return object;
                break;
            case 'loginAs':
                object = new loginAs_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.loginAss, object);
                return object;
                break;
            case 'loginAsPartner':
                object = new loginAsPartner_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.loginAsPartners, object);
                return object;
                break;
            case 'organisationManagement':
                object = new organisationManagement_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.organisationManagements, object);
                return object;
                break;
            case 'stagingDatabase':
                object = new stagingDatabase_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.stagingDatabases, object);
                return object;
                break;
            case 'notification':
                object = new notification_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.notifications, object);
                return object;
                break;
            case 'zigbeeFirmware':
                object = new zigbeeFirmware_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.zigbeeFirmwares, object);
                return object;
                break;
            case 'gatewayTrustList':
                object = new gatewayTrustList_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.gatewayTrustLists, object);
                return object;
                break;
            case 'gatewayTrustedDeviceUntrustRequest':
                object = new gatewayTrustedDeviceUntrustRequest_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.gatewayTrustedDeviceUntrustRequests, object);
                return object;
                break;
            case 'telemetryOperation':
                object = new telemetryOperation_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.telemetryOperations, object);
                return object;
                break;
            case 'aggregateTelemetryGroupRequest':
                object = new aggregateTelemetryGroupRequest_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.aggregateTelemetryGroupRequests, object);
                return object;
                break;
            case 'assetRemoveDataRequest':
                object = new assetRemoveDataRequest_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.assetRemoveDataRequests, object);
                return object;
                break;
            case 'assetAggregateDataRequest':
                object = new assetAggregateDataRequest_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.assetAggregateDataRequests, object);
                return object;
                break;
            case 'gatewayTrustedDeviceAnalysis':
                object = new gatewayTrustedDeviceAnalysis_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.gatewayTrustedDeviceAnalysiss, object);
                return object;
                break;
            case 'aggregateTelemetry':
                object = new aggregateTelemetry_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.aggregateTelemetrys, object);
                return object;
                break;
            case 'instantaneousTelemetry':
                object = new instantaneousTelemetry_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.instantaneousTelemetrys, object);
                return object;
                break;
            case 'organisationSearch':
                object = new organisationSearch_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.organisationSearchs, object);
                return object;
                break;
            case 'gatewayLogDownloadRequest':
                object = new gatewayLogDownloadRequest_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.gatewayLogDownloadRequests, object);
                return object;
                break;
            case 'gatewayEnhancedLogDownloadRequest':
                object = new gatewayEnhancedLogDownloadRequest_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.gatewayEnhancedLogDownloadRequests, object);
                return object;
                break;
            case 'gatewayGod':
                object = new gatewayGod_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.gatewayGods, object);
                return object;
                break;
            case 'assetGod':
                object = new assetGod_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.assetGods, object);
                return object;
                break;
            case 'assetTelemetryBatch':
                object = new assetTelemetryBatch_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.assetTelemetryBatchs, object);
                return object;
                break;
            case 'assetConsumptionBatch':
                object = new assetConsumptionBatch_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.assetConsumptionBatchs, object);
                return object;
                break;
            case 'rawAggregateData':
                object = new rawAggregateData_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.rawAggregateDatas, object);
                return object;
                break;
            case 'assetReset':
                object = new assetReset_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.assetResets, object);
                return object;
                break;
            case 'inspiredLogin':
                object = new inspiredLogin_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.inspiredLogins, object);
                return object;
                break;
            case 'dataUnit':
                object = new dataUnit_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.dataUnits, object);
                return object;
                break;
            case 'itemMetadata':
                object = new itemMetadata_1.default(this.dataService, createObject);
                object = this.dataService.mergeIntoList(this.dataService.itemMetadatas, object);
                return object;
                break;
            default:
                return null;
        }
    }
}
exports.default = SocketService;
//# sourceMappingURL=socket-service.js.map